const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class DocumentCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.CurrentDocumentRecord = {
			DocumentType: '',
			DocumentDate: null,
			Form: 0,
			IDProject: 0,
			Name: '',
			Shift: 'Day',
		};
		this.CurrentSearchFilters = {
			PageSize: 25,
			CurrentPage: 1,
			IDCustomer: 0,
		};
		this.rnis = [];
	}

	async onAfterRenderAsync(pCallback)
	{
		if (this.pict.views.HeadlightPaneDocuments.Intent?.afterRenderHandler)
		{
			this.pict.views.HeadlightPaneDocuments.Intent.afterRenderHandler();
		}
		// set the customer ID if it exists
		this.CurrentSearchFilters.IDCustomer = this.AppData?.DocumentData?.ReportData?.IDCustomer || this.AppData?.CurrentUser.CustomerID || 0;
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.CurrentDocumentRecord.IDProject = tmpProject ? tmpProject.id : 0;
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Enter a project...',
			ElementID: 'DocumentCreate-Entry-Project',
			ParentID: 'DocumentCreate-Container',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: 'Name',
			StickyOption: tmpProject,
			PreselectOption: tmpProject,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});
		this.rnis = this.CurrentDocumentRecord.Project ? (await this.pict.providers.DocumentProvider.getReportNamedInstancesByProject(this.CurrentDocumentRecord.Project, true, true)) : (await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.CurrentSearchFilters.IDCustomer, true, true));
		this.CurrentDocumentRecord.DocumentType = this.rnis[0]?.Hash || '';
		this.CurrentDocumentRecord.Form = this.rnis[0]?.Options?.FormOnly ? 1 : 0;
		// convert the document types to a format that select2 can use
		const dataDocumentTypes = this.rnis.map((pItem) =>
		{
			return {
				id: pItem.Hash,
				text: pItem.Name,
				_isForm: pItem?.Options?.FormOnly ? 1 : 0,
			};
		});
		// DOCUMENT TYPE Selector Filter
		// if we are in a form already, make it's type the sticky on the top of the list
		const tmpDocumentType = dataDocumentTypes.find((pItem) => pItem.id === this.AppData?.DocumentData?.ReportData?.DocumentType);
		this.initializeSelect2Plugin({
			IDCustomer: this.CurrentSearchFilters.IDCustomer,
			dropdownCssClass: 'theme-dark',
			placeholder: 'Enter a document type...',
			ElementID: 'DocumentCreate-Entry-DocumentType',
			ParentID: 'DocumentCreate-Container',
			data: dataDocumentTypes,
			StickyOption: tmpDocumentType,
			PreselectOption: tmpDocumentType,
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});
		this.updateDocumentNamePrefill(tmpDocumentType);

		//  DESIGNATEDDATE date picker
		window.flatpickr('#DocumentCreate-Entry-Date', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'DocumentCreate-Date');
			},
		});

		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		const tmpOptions = {
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			delay: pOptions.delay || 250,
			placeholder: pOptions.placeholder || 'Select...',
			cache: true,
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
		};
		// use local data if provided, else assume server-side paging via entity endpoint
		if (pOptions.data)
		{
			tmpOptions.data = pOptions.data;
		}
		else
		{
			tmpOptions.ajax = {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [ {
							field: 'IDCustomer',
							comparator: 'EQ',
							target: pOptions.IDCustomer || 0,
						} ],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.DocumentCreate.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.DocumentCreate.CurrentSearchFilters.PageSize : data.length === _Pict.views.DocumentCreate.CurrentSearchFilters.PageSize,
					};
				},
			};
		}
		// initialize the select2 plugin
		$('#' + pOptions.ElementID).select2(tmpOptions);
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method updates the current Document record with the value of the specified field.
	 * @param {string} pField - The field to update in the current Document record.
	 * @return {void}
	 */
	handleNewDocumentRecordChange(pField)
	{
		const tmpValue = this.pict.ContentAssignment.readContent(`#DocumentCreate-Entry-${pField}`);
		this.CurrentDocumentRecord[pField] = tmpValue;
		this.log.info(`Current Document Record updated: ${pField} = ${this.CurrentDocumentRecord[pField]}`);
		// update the Document name prefill if the Document type changes
		if (pField === 'DocumentType')
		{
			this.updateDocumentNamePrefill($('#DocumentCreate-Entry-DocumentType').select2('data')[0]);
			this.CurrentDocumentRecord['Form'] = this.rnis.find((rni) =>
			{
				return rni.Hash === tmpValue;
			})?.Options?.FormOnly ? 1 : 0;
		}
	}

	/**
	 * This method updates the Document name prefill based on the selected Document type.
	 * @param {Object} pDocumentTypeSelect2Option - The selected Document type.
	 * @return {void}
	 */
	updateDocumentNamePrefill(pDocumentTypeSelect2Option)
	{
		// Set the new name to current type as prefill
		if (pDocumentTypeSelect2Option && pDocumentTypeSelect2Option.text)
		{
			this.CurrentDocumentRecord.Name = pDocumentTypeSelect2Option.text + ' (New)';
			this.pict.ContentAssignment.assignContent('#DocumentCreate-Entry-Name', this.CurrentDocumentRecord.Name);
		}
		// need to set the form flag for the document
		this.CurrentDocumentRecord.Form = pDocumentTypeSelect2Option?._isForm;
	}

	/**
	 * This method clears the current Document record.
	 * @return {void}
	 */
	clearDocument()
	{
		this.CurrentDocumentRecord = {
			DocumentType: '',
			DocumentDate: null,
			Form: 0,
			IDProject: 0,
			Name: '',
			Shift: 'Day',
		};
		this.renderAsync(() =>
		{
			this.log.info('Document Create view cleared');
		});
	}

	async createNewDocument(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		document.getElementById('DocumentCreate-CreateButton').classList.add('is-loading');
		this.log.info('Creating new Document...');

		const tmpDocumentRecord = {};
		Object.keys(this.CurrentDocumentRecord).forEach((pKey) =>
		{
			switch (pKey)
			{
			case 'Date':
				//defaulting to current time if date is set
				const currentTime = this.pict.providers.DocumentProvider.getDocumentDateCurrentTime();
				tmpDocumentRecord.DocumentDate = this.CurrentDocumentRecord.Date ? this.fable.Dates.dayJS(this.CurrentDocumentRecord.Date + currentTime).toISOString() : null;
				break;
			case 'Project':
				tmpDocumentRecord.IDProject = parseInt(this.CurrentDocumentRecord.Project);
				break;
			case 'Name':
				tmpDocumentRecord.Name = this.CurrentDocumentRecord.Name || (this.CurrentDocumentRecord.DocumentType + ' (New)');
				break;
			case 'Shift':
				tmpDocumentRecord.Shift = this.CurrentDocumentRecord.Shift;
				break;
			case 'DocumentType':
				tmpDocumentRecord.DocumentType = this.CurrentDocumentRecord.DocumentType;
				break;
			case 'Form':
				tmpDocumentRecord.Form = this.CurrentDocumentRecord.Form;
				break;
			default:
				this.pict.log.warn(`Unknown field to map for CreateNewDocument(): ${pKey}`);
				break;
			}
		});

		this.pict.log.info('Creating new Document with the following data:');
		this.pict.log.info(JSON.stringify(tmpDocumentRecord));

		if (!tmpDocumentRecord.IDProject || !tmpDocumentRecord.Name || !tmpDocumentRecord.DocumentType)
		{
			document.getElementById('DocumentCreate-CreateButton').classList.remove('is-loading');
			this.pict.log.warn('Not all required fields are filled out.');
			return;
		}

		// create the new Document
		const newDocumentResult = await this.pict.providers.DocumentProvider.createDocument(tmpDocumentRecord);
		document.getElementById('DocumentCreate-CreateButton').classList.remove('is-loading');
		this.log.info('Document created, going to the Details view...');

		if (this.pict.views.HeadlightPaneDocuments.Intent?.type === 'add')
		{
			this.pict.views.HeadlightPaneDocuments.Intent.handler(newDocumentResult.IDDocument);
		}
		else
		{
			// navigate to the new Document's Details view
			this.pict.views.DocumentDetails.ActiveDocumentDetails = newDocumentResult;
			this.pict.views.DocumentDetails.showDocumentDetailView(null, newDocumentResult.IDDocument, newDocumentResult);
		}
	}
}

module.exports = DocumentCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentCreate',
	DefaultRenderable: 'DocumentCreate',
	DefaultDestinationAddress: '#DocumentCreate-Container',
	Templates:
	[
		{
			Hash: 'DocumentCreate',
			Template: /*html*/`
			{~T:DocumentCreate-Entry~}`,
		},
		{
			Hash: 'DocumentCreate-Entry',
			Template: /*html*/`
			<form id="DocumentCreate-Form" onsubmit="_Pict.views.DocumentCreate.createNewDocument(event)">
				<div class="columns px-4 mb-0 mt-1">
					{~T:DocumentCreate-Entry-ProjectSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:DocumentCreate-Entry-DocumentTypeSelector~}
				</div>
				<div class="columns px-4 mb-0">
					{~T:DocumentCreate-Entry-NameInput~}
				</div>
				<div class="columns px-4 mb-0 theme-dark">
					{~T:DocumentCreate-Entry-ShiftSelector~}
					{~T:DocumentCreate-Entry-DateInput~}
				</div>
				<div class="columns px-4 mb-0 mt-1">
					<div class="column">
						<div class="buttons is-right">
							<button id="DocumentCreate-ClearButton" type="button" class="button is-primary is-dark" title="Clear documents" onclick="_Pict.views.DocumentCreate.clearDocument()">
								<span class="icon">
									<i class="fa fa-fw fa-refresh"></i>
								</span>
								<span class="icon-text">Clear</span>
							</button>
							<button id="DocumentCreate-CreateButton" type="submit" class="button is-primary" title="Create new document">
								<span class="icon">
									<i class="fa fa-fw fa-plus"></i>
								</span>
								<span class="icon-text">Create New Document</span>
							</button>
						</div>
					</div>
				</div>
			</form>`,
		},
		{
			Hash: 'DocumentCreate-Entry-NameInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Name">Document Name</label>
					<div class="control">
						<input 
							id="DocumentCreate-Entry-Name" 
							class="input" 
							type="text" 
							placeholder="Enter a name for the Document..."
							autocomplete="off"
							{~SelectOnFocus:Record~}
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Name')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-DateInput',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Date">Document Date</label>
					<div class="control">
						<input 
							id="DocumentCreate-Entry-Date" 
							class="input" 
							type="date" 
							placeholder="Enter a date for the Document..." 
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Date')"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-DocumentTypeSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-DocumentType">Document Type</label>
					<div class="control select is-fullwidth">
						<select 
							id="DocumentCreate-Entry-DocumentType" 
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('DocumentType')"
						>{~TS:DocumentCreate-Entry-DocumentTypeSelector-SelectedOptions:Context[0].CurrentSearchFilters.DocumentType~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-ProjectSelector',
			Template: /*html*/`
			<div class="column" id="DocumentCreate-Entry-Project-Wrapper">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Project">Project</label>
					<div class="control select is-fullwidth">
						<select 
							id="DocumentCreate-Entry-Project" 
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Project')"
						>{~TS:DocumentCreate-Entry-ProjectSelector-SelectedOptions:Context[0].CurrentSearchFilters.Project~}</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Entry-ShiftSelector',
			Template: /*html*/`
			<div class="column">
				<div class="field">
					<label class="label block" for="DocumentCreate-Entry-Shift">Shift</label>
					<div class="control select is-fullwidth">
						<select 
							id="DocumentCreate-Entry-Shift" 
							class="input"
							onchange="_Pict.views.DocumentCreate.handleNewDocumentRecordChange('Shift')"
						>
							<option value="Day" selected>Day</option>
							<option value="Night">Night</option>
							<option value="Swing">Swing</option>
						</select>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentCreate-Enty-ProjectSelector-SelectedOptions',
			Template: /*html*/`<option value="{~D:Record.IDProject~}" selected>{~D:Record.Name~}</option>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DocumentCreate',
			TemplateHash: 'DocumentCreate',
			DestinationAddress: '#DocumentCreate-Container',
			RenderType: 'replace',
		},
	],
};
